import * as React from "react";
import Layout from "../Layout";
import ProviderContent from "./Content";
import { RootState } from "../../store/configureStore";
import { useSelector } from "react-redux";

const Provider: React.FC = () => {
  const {
    breadcrumbs = [
      {
        url: "/",
        title: "首页",
      },
      {
        url: "/provider",
        title: "服务点",
      },
    ],
  } = useSelector((state: RootState) => state.ProviderPage);
  return (
    <Layout breadcrumbs={breadcrumbs}>
      <ProviderContent />
    </Layout>
  );
};

export default Provider;
